import { Controller } from "@hotwired/stimulus"

// Opens the native mobile voice assistant sheet via ReactNativeWebView postMessage.
export default class extends Controller {
  static values = { tenantId: Number }

  openAssistant() {
    if (!window.ReactNativeWebView) return

    window.ReactNativeWebView.postMessage(
      JSON.stringify({
        action: "voice_assistant_open",
        data: { tenantId: this.tenantIdValue || null },
      })
    )
  }
}
